import { makeRequest } from "../util/AxiosInstance";

export const useCalBooking = (admin = false) => {
    /**
     * Get a specific booking by UID
     * @param {string} bookingUid - The unique identifier of the booking
     * @returns {Promise} - Response from the API
     */
    const getBooking = async (bookingUid) => {
        const response = await makeRequest("get", `/${admin ? 'admin' : 'cal'}/bookings/${bookingUid}`);
        return response.data;
    };

    /**
     * Cancel a booking
     * @param {string} bookingUid - The unique identifier of the booking
     * @param {Object} data - Cancellation data
     * @param {string} data.cancellationReason - Reason for cancellation
     * @param {boolean} data.cancelSubsequentBookings - Whether to cancel subsequent bookings
     * @returns {Promise} - Response from the API
     */
    const cancelBooking = async (bookingUid, data) => {
        const response = await makeRequest(
            "post",
            `/cal/bookings/${bookingUid}/cancel`,
            data
        );
        return response.data;

    };

    /**
     * Reschedule a booking
     * @param {string} bookingUid - The unique identifier of the booking
     * @param {Object} data - Rescheduling data
     * @param {string} data.start - New start time in ISO 8601 format
     * @param {string} data.reschedulingReason - Reason for rescheduling
     * @returns {Promise} - Response from the API
     */
    const rescheduleBooking = async (bookingUid, data) => {
        const response = await makeRequest(
            "post",
            `/cal/bookings/${bookingUid}/reschedule`,
            data
        );
        return response.data;

    };

    /**
     * Approve/Confirm a booking
     * @param {string} bookingUid - The unique identifier of the booking
     * @returns {Promise} - Response from the API
     */
    const approveBooking = async (bookingUid) => {
        const response = await makeRequest(
            "post",
            `/cal/bookings/${bookingUid}/confirm`
        );
        return response.data;

    };

    /**
     * Remove a booking (admin only)
     * @param {string} bookingUid - The unique identifier of the booking
     * @returns {Promise} - Response from the API
     */
    const removeBooking = async (bookingUid) => {
        const response = await makeRequest(
            "delete",
            `/cal/bookings/${bookingUid}/remove`
        );
        return response.data;
    };

    return {
        getBooking,
        cancelBooking,
        rescheduleBooking,
        approveBooking,
        removeBooking
    };
};

export default useCalBooking; 